
(function () {
  'use strict';

  angular.module('itxApp.common').factory('cmsLookbookSvc', cmsLookbookSvc);

  cmsLookbookSvc.$inject = [
    '$q',
    'Category',
    'Product',
    'BundleSvc',
    'ngDialog',
    'productPopupSvc',
    'imLookbookService',
    '$http',
    'CmsConfigSvc',
    'ItxConfigurationSvc',
    'imLookbookCmsService',
    'imMicrositeService',
    '$rootScope'
  ];

  function cmsLookbookSvc($q, Category, Product, BundleSvc, ngDialog, productPopupSvc, imLookbookService, $http, CmsConfigSvc, ItxConfigurationSvc, imLookbookCmsService, imMicrositeService, $rootScope) {

    var _this = this;
    _this.bundles = [];
    var pending = false;

    $rootScope.$on('openProductPopup', function ($event, productInfo) {
      managementActionCms(productInfo);
    });

    var service = {
      getBundles: getBundles,
      openDialogBundle: openDialogBundle,
      openDialogProduct: openDialogProduct,
      managementActionCms: managementActionCms,
      checkCmsPage: checkCmsPage,
      printDebugHtml: printDebugHtml
    };

    return service;


    function getBundles() {
      var promiseBundleProducts = [];
      var deferred = $q.defer();

      new Category({
        id: inditex.iCategoryId
      }).fetch().then(function (category) {
        
        _.forEach(category.visibleProducts, function (bundle) {
          promiseBundleProducts.push(BundleSvc.parseBundle(bundle));
        });

        $q.all(promiseBundleProducts).then(function (products) {
          _this.bundles = products;
          if(ItxConfigurationSvc.isDebugActive() && ItxConfigurationSvc.getDebugOptions().productInfo) {
            printDebugHtml(_this.bundles);
          }
          deferred.resolve(products);
        });

      }).Catch(function () {
        deferred.reject(true);
      });

      return deferred.promise;
    }

    function managementActionCms(piece) {
      if(!pending){
        pending = true;
        let product = _findBundle(parseInt(piece.productId));
        if(product && product.gridElemType === "BUNDLE"){
          openDialogBundle(product);
          pending = false;
        } else {
          new Product(piece.productId)
            .fetch()
            .then(p => {
              imLookbookCmsService.createProductEvent('ver_vista_rapida_bundle', p);
              imLookbookCmsService.createPopupViewBundle(p);
              if(p.isBundleBean){
                BundleSvc.parseBundle(p).then(function(bundle){
                  openDialogBundle(bundle);
                  pending = false;
                });
              } else {
                openDialogProduct(p);
                pending = false;
              }
          });
        }
      }
    }

    function openDialogBundle(bundle) {
      var className = 'ngdialog-theme-plain new-modal ma-modal-sm ngdialog-featured-bundle';
      ngDialog.open({
        template:
          '<div class="cmp-bundle-v19-detail">' +
          '<lazy-cmp-bundle products="ngDialogData.bundleProducts" home=true></lazy-cmp-bundle>' +
          '</div>',
        className: className,
        bodyClassName: 'ng-dialog-featured-bundle-open',
        plain: true,
        showClose: true,
        data: {
          bundleProducts: bundle.bundleProducts
        },
        preCloseCallback: function () {
          $('body').css('overflow', '');
          try {
            if ($("#page[ng-controller^='ItxMicroSiteCtrl']").length > 0) {
              imMicrositeService.sendPageview();
            } else {
              imLookbookCmsService.sendPageviewLookbook();
            }
          }
          catch(e) {}   
        }
      });
      $('body').css('overflow', 'hidden');
    }

    function openDialogProduct(idProduct) {
      productPopupSvc.openProductPopup(idProduct);
    }

    function _findBundle(bundleId) {
      _.each(_this.bundles, function (bundle) {
        if (bundle.id === bundleId) {
          _this.selectedBundle = bundle;
          imLookbookService.eventSelectLook(bundle.detail.reference);
        }
      });
      return _this.selectedBundle;
    };


    function checkCmsPage() {
      var deferred = $q.defer();
      _this.config = JSON.parse(JSON.stringify(CmsConfigSvc.getConfigCms()));
      var category = inditex.iCategoryId;
      _this.url = _this.config.apiMaterializedUrl + '/page/lookbook-' + category + '?country=ES&lang=es';
      $http.get(_this.url).then(function (result) {
        deferred.resolve(true);
      }).catch(function (err) {
        deferred.resolve(false);
      });
      return deferred.promise;
    }
  }


  function printDebugHtml(arrBundles) {
    var lookbookDebug = document.getElementById('debug-lookbook');
    _.forEach(arrBundles, function (bundle) {
      var ulLevel1      = document.createElement('UL');
      var liBundle      = document.createElement('LI');
      var h4Title       = document.createElement('H5');
      var textId        = document.createTextNode('Id: ' + bundle.id);
      var textReference = document.createTextNode('Reference: ' + bundle.detail.reference);
      var ulLevel2      = document.createElement('UL');
      h4Title.appendChild(textId);
      liBundle.appendChild(h4Title)
      liBundle.appendChild(textReference)
      ulLevel1.appendChild(liBundle);
      ulLevel1.style.float = 'left';
      liBundle.className = 'info-a';
      _.forEach(bundle.bundleProductSummaries, function (product) {
        var liProduct     = document.createElement('LI');
        var h6Product     = document.createElement('H6');
        var textId        = document.createTextNode('Id: ' + product.id);
        var textReference = document.createTextNode('Reference: ' + product.detail.reference);
        h6Product.appendChild(textId)
        liProduct.appendChild(h6Product);
        liProduct.appendChild(textReference);
        ulLevel2.appendChild(liProduct);
        liProduct.className = 'info-b';
      });
      ulLevel1.appendChild(ulLevel2);
      lookbookDebug.appendChild(ulLevel1);
    });

  }

})();